const OPFS_DIR = 'geotag-thumb-cache';

const isOpfsAvailable = () => {
  return (
    typeof navigator !== 'undefined' &&
    typeof (navigator as any).storage?.getDirectory === 'function' &&
    typeof crypto !== 'undefined' &&
    typeof crypto.subtle?.digest === 'function'
  );
};

const toHex = (buffer: ArrayBuffer) => {
  const bytes = new Uint8Array(buffer);
  let out = '';
  for (let i = 0; i < bytes.length; i += 1) {
    out += bytes[i].toString(16).padStart(2, '0');
  }
  return out;
};

const hashKey = async (key: string) => {
  const data = new TextEncoder().encode(key);
  const digest = await crypto.subtle.digest('SHA-256', data);
  return toHex(digest);
};

const getOpfsDir = async () => {
  if (!isOpfsAvailable()) return null;
  const root = await (navigator as any).storage.getDirectory();
  return await root.getDirectoryHandle(OPFS_DIR, { create: true });
};

export const getOpfsThumb = async (key: string): Promise<Blob | null> => {
  try {
    const dir = await getOpfsDir();
    if (!dir) return null;
    const fileName = await hashKey(key);
    const handle = await dir.getFileHandle(fileName);
    return await handle.getFile();
  } catch {
    return null;
  }
};

export const saveOpfsThumb = async (key: string, blob: Blob): Promise<void> => {
  try {
    const dir = await getOpfsDir();
    if (!dir) return;
    const fileName = await hashKey(key);
    const handle = await dir.getFileHandle(fileName, { create: true });
    const writable = await handle.createWritable();
    await writable.write(blob);
    await writable.close();
  } catch {
    // ignore OPFS errors
  }
};

export const canUseOpfsThumbs = () => isOpfsAvailable();

export const clearOpfsThumbs = async (): Promise<void> => {
  try {
    const dir = await getOpfsDir();
    if (!dir) return;
    for await (const [name] of dir.entries()) {
      await dir.removeEntry(name);
    }
  } catch {
    // ignore OPFS errors
  }
};
